/**
 * `/contact` — the support ticket form.
 *
 * The public site's contact page sends a signed-out visitor to this host's
 * sign-in with `?next=/contact`; `validateNext` accepts the same-origin target,
 * the auth shell honours it, and this route is where that lands. Before it
 * existed the round trip ended on the catch-all 404.
 *
 * The form itself is `/cases/new` — reused rather than copied. One form, one
 * served vocabulary (`GET /caseTypes`) and one create mutation mean the two
 * URLs can never drift into two different ways of raising a case.
 */
import type { RouteObject } from 'react-router-dom';

export const contactRoute: RouteObject = {
  path: 'contact',
  lazy: async () => {
    const { NewCasePage } = await import('./new/NewCasePage');
    return { Component: NewCasePage };
  },
};
